// 画像の遅延読み込み
export default function lazyLoad() {
  document.addEventListener('DOMContentLoaded', () => {
    const images = document.querySelectorAll('.js-lazyload');
    const elements = Array.prototype.slice.call(images);
    const OPTIONS = {
      rootMargin: '100px',
      threshold: [0, 1],
    };

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          return
        }

        const target = entry.target;
        target.classList.remove('is-unload');
        if(target.src) {
          target.src = target.dataset.src;
        }
        if(target.srcset) {
          target.srcset = target.dataset.src;
        }
        observer.unobserve(target);
      });
    }, OPTIONS);

    elements.forEach((element) => {
      element.classList.add('is-unload');
      observer.observe(element);
    });
  });
}

lazyLoad();
